import FeatureGates from '@atlaskit/feature-gate-js-client';
import { addSpanToAll } from '@atlaskit/react-ufo/interaction-metrics';
import { initUFO } from '@atlassian/help-center-common-util/analytics/react-ufo';
import { embedFFDataToUFO } from '@atlassian/help-center-common-util/analytics/ufo-feature-flags';
import { initialiseFeatureGates } from '@atlassian/help-center-common-util/feature-manager';
import type { WindowFlagVars } from '@atlassian/help-center-common-util/feature-manager';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
import '@atlaskit/css-reset/bundle.css';
import { sentryQueue } from '@atlassian/help-center-common-util/sentry-queue';

const globalVar = (typeof window !== 'undefined' ? window : globalThis) as unknown as WindowFlagVars;

const PERFORMANCE_MARKS = {
    // These happen to currently exist in the Jira monolith. Will replace them with more meaningful marks on the backend and then update here
    BEFORE_FRAGMENT: 'jsd.performance.profile.customer.portal.wrm.resources.loaded',
    AFTER_FRAGMENT: 'jsd.performance.profile.customer.portal.first.chunk.loaded',
} as const;

// Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope,@atlaskit/platform/no-direct-document-usage
document.addEventListener('DOMContentLoaded', () => {
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const element = document.getElementById('page');
    element && element.parentElement && element.parentElement.removeChild(element);
    initialiseFeatureGates(globalVar)
        .catch((err: Error) => sentryQueue.pushError(err))
        .finally(() => {
            if (!__SERVER__) {
                try {
                    !__SERVER__ && initUFO();
                } catch (err) {
                    sentryQueue.pushError(err);
                }
                embedFFDataToUFO();
            }
            const requiredBootstrapMarkBefore = performance.now();
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, global-require
            const { bootstrap } = require('./bootstrap');
            const requiredBootstrapMarkAfter = performance.now();
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            bootstrap();
            const executedBootstrapMarkAfter = performance.now();
            if (!__SERVER__ && FeatureGates.checkGate('custom_ufo_spans_for_help_center_bootstrap')) {
                const beforeFragment =
                    performance.getEntriesByName &&
                    performance.getEntriesByName(PERFORMANCE_MARKS.BEFORE_FRAGMENT)[0]?.startTime;
                const afterFragment =
                    beforeFragment && performance.getEntriesByName(PERFORMANCE_MARKS.AFTER_FRAGMENT)[0]?.startTime;
                beforeFragment &&
                    afterFragment &&
                    addSpanToAll('custom', 'fragment executed', [{ name: 'bootstrap' }], beforeFragment, afterFragment);
                addSpanToAll(
                    'custom',
                    'bootstrap required',
                    [{ name: 'bootstrap' }],
                    requiredBootstrapMarkBefore,
                    requiredBootstrapMarkAfter
                );
                addSpanToAll(
                    'custom',
                    'bootstrap executed',
                    [{ name: 'bootstrap' }],
                    requiredBootstrapMarkAfter,
                    executedBootstrapMarkAfter
                );
            }
        });
});
